import { ModalAskStepData } from '@app/shared/modal-ask-step/modal-ask-step.component';

/** Primera confirmación al omitir validación de gastos (OC) vinculados (grupo Dirección). */
export const UPLOAD_DELIVERY_PROOFS_CRM_BYPASS_FIRST_CONFIRM: ModalAskStepData = {
    title: 'Proyecto sin gastos (OC) vinculados',
    message:
        'El proyecto en CRM no tiene gastos (OC) vinculados, requisito habitual para cargar acuses de entrega. Como usuario de Dirección puedes continuar de todas formas. ¿Deseas avanzar?',
    buttonFalse: 'Cancelar',
    buttonTrue: 'Sí, continuar'
};

/** Segunda confirmación (aviso final antes de abrir la carga). */
export const UPLOAD_DELIVERY_PROOFS_CRM_BYPASS_SECOND_CONFIRM: ModalAskStepData = {
    title: '¿Confirmas continuar sin gastos vinculados?',
    message:
        'Los acuses se cargarán aunque el proyecto en CRM no tenga gastos (OC) vinculados. Esta decisión queda bajo tu responsabilidad.',
    buttonFalse: 'No, volver',
    buttonTrue: 'Sí, estoy seguro'
};
